import {
  blackColor,
  whiteColor,
  hexToRgb,
  defaultFont,
  defaultFontButton,
  dangerColor,
  grayColor,
} from "assets/jss/material-dashboard-react.js";

const cardStyle = {
  card: {
    border: 0,
    marginBottom: 15,
    marginTop: 20,
    borderRadius: "6px",
    color: "rgba(" + hexToRgb(blackColor) + ", 0.87)",
    background: whiteColor,
    width: "100%",
    boxShadow: "0 1px 4px 0 rgba(" + hexToRgb(blackColor) + ", 0.14)",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    minWidth: "0",
    wordWrap: "break-word",
    fontSize: ".875rem",
  },
  cardPlain: {
    background: "transparent",
    boxShadow: "none",
  },
  cardProfile: {
    marginTop: "30px",
    textAlign: "center",
  },
  cardChart: {
    "& p": {
      marginTop: "0px",
      paddingTop: "0px",
    },
  },
  titleCard: {
    marginTop: "20px",
    ...defaultFont,
    fontSize: 18,
    fontWeight: "bold",
    textAlign: "center",
    letterSpacing: "1px !important",
  },
  titleCardSub: {
    marginTop: "20px",
    ...defaultFont,
    fontSize: 16,
    fontWeight: "400",
    textAlign: "center",
  },
  titleCardSub2: {
    ...defaultFont,
    fontSize: 14,
    fontWeight: "bold",
    textAlign: "center",
  },
  fontParagraph: {
    ...defaultFont,
    fontSize: 16,
    fontWeight: "400",
  },
  containerStyle: {
    paddingLeft: 25,
    paddingRight: 30,
    marginTop: 40,
    marginBottom: 30,
  },
  iconStyle: {
    color: dangerColor[0],
  },
  iconSubTitle: {
    fontSize: 26,
    color: "#000",
    verticalAlign: "middle",
    margin: 4,
  },
  buttonSubmit: {
    width: 200,
    padding: "8px 20px",
    fontSize: 14,
    color: "#fff",
    ...defaultFontButton,
    backgroundColor: dangerColor[0],
    borderColor: dangerColor[0],
    borderRadius: 1,
    "&:hover": {
      backgroundColor: blackColor,
    },
    "&:disabled": {
      backgroundColor: grayColor[11],
    },
  },
  backButton: {
    width: 200,
    padding: "8px 20px",
    fontSize: 14,
    color: "#fff",
    ...defaultFontButton,
    backgroundColor: grayColor[0],
    borderColor: grayColor[0],
    borderRadius: 1,
    "&:hover": {
      backgroundColor: blackColor,
    },
    "&:disabled": {
      backgroundColor: grayColor[11],
    },
  },
  mapStyle: {
    position: "relative",
    height: "400px",
    flexWrap: "inherit",
    width: "100%",
    //marginTop: 30,
  },
  fontParagraphAlert: {
    ...defaultFont,
    fontSize: 12,
    fontWeight: "bold",
    color: dangerColor[1],
  },
  listCatalogSelect: {
    backgroundColor: grayColor[10],
  },
  img404: {
    width: "25%",
    height: "auto",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    objectFit: "cover",
  },
  blockReds: {
    color: "inherit",
    textTransform: "uppercase",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "none",
    },
  },
  textField: {
    width: "90%",
    marginTop: "50px",
  },
  lineBottom: {
    marginTop: 5,
    background: dangerColor[0],
    padding: 1,
    borderRadius: 10,
    width: 100,
    boxShadow:
      "0 12px 20px -10px rgba(" +
      hexToRgb(dangerColor[0]) +
      ",.28), 0 4px 20px 0 rgba(" +
      hexToRgb(dangerColor[0]) +
      ",.12), 0 7px 8px -5px rgba(" +
      hexToRgb(dangerColor[0]) +
      ",.2)",
  },
  cardImgLoginMail: {
    objectFit: "cover",
    objectPosition: "center",
    verticalAlign: "middle",
    width: 190,
    height: 120,
  },
  cardImgLoginPass: {
    objectFit: "cover",
    objectPosition: "center",
    verticalAlign: "middle",
    width: 210,
    height: 130,
  },
};

const themeCss = {
  palette: {
    primary: {
      main: dangerColor[0],
      contrastText: "#fff",
    },
  },
};

const ColorlibConnectorCss = {
  alternativeLabel: {
    verticalAlign: "middle",
  },
  active: {
    "& $line": {
      backgroundImage:
        "linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)",
    },
  },
  completed: {
    "& $line": {
      backgroundImage:
        "linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)",
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: "#eaeaf0",
    borderRadius: 1,
  },
};

const HtmlTooltipCss = {
  tooltip: {
    ...defaultFont,
    backgroundColor: "#000",
    color: "#fff",
    with: 400,
    fontSize: 12,
  },
};

const progressLinearCss = {
  colorPrimary: {
    backgroundColor: dangerColor[0],
    boxShadow:
      "0 12px 20px -10px rgba(" +
      hexToRgb(dangerColor[0]) +
      ",.28), 0 4px 20px 0 rgba(" +
      hexToRgb(dangerColor[0]) +
      ",.12), 0 7px 8px -5px rgba(" +
      hexToRgb(dangerColor[0]) +
      ",.2)",
  },
  barColorPrimary: {
    backgroundColor: whiteColor,
    boxShadow:
      "0 12px 20px -10px rgba(" +
      hexToRgb(whiteColor) +
      ",.28), 0 4px 20px 0 rgba(" +
      hexToRgb(whiteColor) +
      ",.12), 0 7px 8px -5px rgba(" +
      hexToRgb(whiteColor) +
      ",.2)",
  },
};

export {
  cardStyle,
  themeCss,
  ColorlibConnectorCss,
  HtmlTooltipCss,
  progressLinearCss,
};
